<template>
    <div>
      登录中...
    </div>
</template>

<script>
import qs from 'qs'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import Vue from 'vue'
import oauth2 from '@/config/oauth2'
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      token: this.$route.query.token
    }
  },
  created () {
    let token = this.token ? this.token : localStorage.getItem('pro__token')
    if (!token) {
      alert('登录失败')
      return
    }
    if (this.$ls.get(ACCESS_TOKEN)) {
      this.Logout({}).then(() => {
        // token = JSON.parse(token)
        const params = qs.stringify({ token: token })
        this.$http.post('/api/v1/portal/login', params).then(resp => {
          if (resp.code === 200) {
            this.$store.dispatch('SetToken', resp.result.token).then(() => {
              this.$router.push('/dashboard/workplace')
            }).catch((error) => {
              this.error = error.message
            })
          } else {
            alert('登录失败')
          }
        })
      }).catch(err => {
        this.$message.error({
          title: '错误',
          description: err.message
        })
      })
    } else {
      // token = JSON.parse(token)
      const params = qs.stringify({ token: token })
      this.$http.post('/api/v1/portal/login', params).then(resp => {
        if (resp.code === 200) {
          this.$store.dispatch('SetToken', resp.result.token).then(() => {
            this.$router.push('/dashboard/workplace')
          }).catch((error) => {
            this.error = error.message
          })
        } else {
          alert('登录失败')
        }
      })
    }
  },
  methods: {
    ...mapActions(['Logout'])
  }
}
</script>

<style lang="less" scoped>
</style>
